import Firebase from "firebase"
import Promise from "bluebird"
import helper from './../helper'

const moment = require("moment")

const config = {
  apiKey: "AIzaSyA01Jc68qRsWA3HLuD2zX6WlQDqwzCr0e4",
  authDomain: "asspm-3903b.firebaseapp.com",
  databaseURL: "https://asspm-3903b.firebaseio.com",
  projectId: "asspm-3903b",
  storageBucket: "asspm-3903b.appspot.com",
  messagingSenderId: "10871404BULK_SIZE7002"
};

console.log(config)
const db = Firebase.initializeApp(config).database()

console.log("signInWithEmailAndPassword")
Firebase.auth().signInWithEmailAndPassword("florent.blin@nielsen.com", "Wf93tz31")
  .then(response => {
    console.log(response)
  })
  .catch(err => {
    console.log(err)
  })

const filesPath = "https://www.asspm.fr/lab/data/apps/asspm/files/";
const parser = new DOMParser();
const cache = {
  last: {},
  items: {},
  promises: {}
}
const BULK_SIZE = 15;

export function createAdminRepository() {
  return {all() {return all("admins")}}
}

export function createCallupRepository() {
  return {all() {return all("callups")}}
}

export function createPartnerRepository() {
  return {all() {return all("partners")}}
}

export function createMenuRepository() {
  return {all() {return all("menus")}}
}

export function createCompetitionRepository() {
  return {all() {return all("competitions")}}
}

export function createFlyerRepository() {
  return {all() {return all("flyers")}}
}

export function createGazetteRepository() {
  return {all() {return all("gazettes")}}
}

export function createTeamRepository() {
  return {
    all() {return all("teams")},
    findOne(field, value) {return findOne("teams", field, value)},
    save(team) {return upsert("teams", team)}
  }
}

export function createPaperRepository() {

  function modelize(p) {
    return _.assign(p, {
      "image": (file) => {
        let image = file || _.get(p, "files.0", "");
        image = image.replace(/ /g, "%20")
        return image ? filesPath + image : "";
      },
      "link": () => `news/${p.deeplink}`,
      "extract": () => truncate(parse(_.get(p, "html"))),
      "content": () => p.html
    })
  }

  function all(chunk = 0) {
    return get("papers", "created", chunk, modelize)
  }

  function deeplink(deeplink) {
    return findOne("papers", "deeplink", deeplink)
      .then(modelize)
  }

  function save(paper) {
    return upsert("papers", _.omit(paper, ["image", "link", "extract", "content"/*, "key", "auth", "display"*/]))
  }

  function remove(paper) {
    return _remove("papers", paper);
  }

  function _remove(ref, item) {
    var query = db.ref(ref + "/" + item.key);
    return query.remove()
      .then(function() {
        console.log("Remove succeeded.")
      })
      .catch(function(error) {
        console.log("Remove failed: " + error.message)
      });
  }

  return {
    all,
    save,
    remove,
    deeplink
  }

}

function findOne(ref, field, value) {
  return Promise.resolve(db.ref(ref).orderByChild(field).equalTo(value).once("value"))
    .then(data => _(normalize(data.val())).values().first())
    .tap(data => console.info(value, data))
}

function upsert(ref, item) {
  if (_.isArray(item)) return Promise.all(_.map(item, _.partial(upsert, ref)))
  //console.log("upsert", item)
  if (_.isNil(item.key)) {
    _.assign(item, {
      // id: uuid.v1(),
      created: moment().format("YYYY-MM-DD HH:mm:ss")
    })
    var query = db.ref(ref)
    var newRef = query.push();
    newRef.set(item, (e) => {
      e && console.error(e)
    })
  } else {
    _.assign(item, {
      updated: moment().format("YYYY-MM-DD HH:mm:ss")
    })
    query = db.ref(ref + "/" + item.key)
    return query.update(_.omit(item, "key"), (e) => {
      e && console.error(e)
    })
  }
}

function parse(html) {
  const doc = parser.parseFromString(html, "text/html");
  return doc.body.textContent;
}

function truncate(text) {
  return text.length > 200 ? text.substring(0, 200) + " ..." : text;
}

function normalize(obj) {
  const r = []
  _.forOwn(obj, (value, key) => {
    r.push(_.set(value, "key", key))
  });
  return r
}

function all(ref) {
  const promises = promised(ref) || {};
  /* reply from promises cache */
  const chunk = 0;
  if (_.get(promises, chunk)) return _.get(promises, chunk);
  //if (ref == "callups") debugger
  /* fetching data */
  const promise = Promise.resolve(db.ref(ref).once("value")
    .then(data => _.sortBy(normalize(data.val()), "order")))
  /* store promises */
  promised(ref, _.set(promises, chunk, promise));
  /* reply promise */
  return promise;
}

function get(ref, key, chunk = 0, modelize = m => m) {
  if (_.get(items(ref), "length", 0) > chunk + BULK_SIZE) {
    /* reply from items cache */
    return Promise.resolve(items(ref).slice(chunk, chunk + BULK_SIZE));
  }
  const promises = promised(ref) || {};
  /* reply from promises cache */
  if (_.get(promises, chunk)) return _.get(promises, chunk);
  /* fetching data */
  const promise = fetch(ref, key)
    .map(modelize)
  /* store promises */
  promised(ref, _.set(promises, chunk, promise));
  /* reply promise */
  return promise;
}

function last(ref, item) {
  return helper.prop(cache.last, ref, item);
}

function items(ref, items) {
  return helper.prop(cache.items, ref, _.compact(items));
}

function promised(ref, promises) {
  return helper.prop(cache.promises, ref, promises);
}

function fetch(ref, key, bulkSize = BULK_SIZE) {
  let papers;
  //console.log("fetch", ref, _.json(_.omit(last(ref), "html")));
  if (last(ref)) {
    papers = db.ref(ref).orderByChild(key).endAt(_.get(last(ref), key)).limitToLast(bulkSize + 1).once("value")
  } else {
    papers = db.ref(ref).orderByChild(key).limitToLast(bulkSize).once("value")
  }
  return Promise.resolve(papers)
    .then(snap => {
      let data;
      const val = normalize(snap.val());
      if (last(ref)) {
        data = _.sortBy(_.map(val), key).reverse().slice(1);
      } else {
        data = _.sortBy(_.map(val), key).reverse().slice(0, bulkSize);
      }
      last(ref, _.last(data));
      items(ref, _.concat(items(ref), data));
      return data;
    });
}